import { pathBuilder } from 'config/paths/index';
import { root as hubRoot } from 'config/paths/requirementControls';

export const root = `${hubRoot}/requirements`;
export default pathBuilder(root);
